import { API_ROOT, dispatchGetJSONAsync, completeJSONAsync } from './BaseApi';
import appdata from '../Services/appdata';

const ApiProjectPerformance = () => {
  const getSummary = async (selectedYear, DateKey) => {
    let queryParams = '';
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');

    var queryjson = [];
    queryjson[0] = selectedYear;
    let filter = DateKey
      ? { FYs: queryjson, DimDateKeys: DateKey.slice() }
      : { FYs: queryjson };

    queryParams += '?filter=' + JSON.stringify(filter);
    let task = await dispatchGetJSONAsync(
      `${API_ROOT}/projectperformance/${company_id}/${company_org_id}/summary${queryParams}`,
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };

  const getDetail = async (selectedYear, DateKey) => {
    let queryParams = '';
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');

    var queryjson = [];
    queryjson[0] = selectedYear;
    let filter = DateKey
      ? { FYs: queryjson, DimDateKeys: DateKey.slice() }
      : { FYs: queryjson };

    queryParams += '?filter=' + JSON.stringify(filter);
    let task = await dispatchGetJSONAsync(
      `${API_ROOT}/projectperformance/${company_id}/${company_org_id}/detail${queryParams}`,
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };

  return {
    getSummary,
    getDetail,
  };
};

export default ApiProjectPerformance();
